import {
  UI_CONFIG_SET_REFRESH_INTERVAL,
  UI_CONFIG_RESET
} from '../constants/configConstants';

// Initial state with default values
const initialState = {
  refreshInterval: 60000, // Default to 60 seconds
};

export const uiConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case UI_CONFIG_SET_REFRESH_INTERVAL:
      return {
        ...state,
        refreshInterval: action.payload
      };
    case UI_CONFIG_RESET:
      return initialState;
    default:
      return state;
  }
}; 